import React from 'react';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import { FormattedMessage } from '@atlassian/jira-intl';
import { useIntlV2 as useIntl } from '@atlassian/jira-intl/src/v2/use-intl.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { SCREEN_SCHEMES, SCREENS } from '../../constants';
import messages from './messages';

const SCREEN_SCHEME_LINK = '/jira/settings/issues/screen-schemes';
const SCREEN_LINK = '/jira/settings/issues/screens';

export default function PageDescription() {
	const { formatMessage } = useIntl();
	return (
		<>
			<p>
				<FormattedMessage
					{...messages.issueTypeScreenSchemesDescription}
					values={{
						screenSchemeLink: (
							<Link
								href={SCREEN_SCHEME_LINK}
								target="_blank"
								// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
								onClick={(e, analyticsEvent) => {
									fireUIAnalytics(analyticsEvent, SCREEN_SCHEMES);
								}}
							>
								{formatMessage(messages.screenScheme)}
							</Link>
						),
						screenLink: (
							<Link
								href={SCREEN_LINK}
								target="_blank"
								// @ts-expect-error - TS7006 - Parameter 'e' implicitly has an 'any' type. | TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
								onClick={(e, analyticsEvent) => {
									fireUIAnalytics(analyticsEvent, SCREENS);
								}}
							>
								{formatMessage(messages.screen)}
							</Link>
						),
					}}
				/>
			</p>
			<p>
				<small>{formatMessage(messages.issueTypeScreenSchemesNote)}</small>
			</p>
		</>
	);
}
